import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { type FC } from "react";

import * as Styled from "./EmbedMessage.styles";

interface IEmbedMessageProps {
  title: string;
  detail?: string;
}

export const EmbedMessage: FC<IEmbedMessageProps> = ({ title, detail }) => (
  <Styled.Root>
    <ErrorOutlineIcon color="error" fontSize="small" />
    <Styled.Title>{title}</Styled.Title>
    {detail && <Styled.Detail>{detail}</Styled.Detail>}
  </Styled.Root>
);
